import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["valueExpr", "displayExpr", "tabs", "value", "tabProps", "onChange", "name", "formLoop", "panelGridProps", "stackContainerProps", "tabPanelProps", "disableDivider", "errors"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { WarningAmberRounded } from '@mui/icons-material';
import TabContext from '@mui/lab/TabContext';
import TabPanel from '@mui/lab/TabPanel';
import { Divider, Grid, Stack, Tab, tabClasses, Tabs } from '@mui/material';
import { useMemo } from 'react';
import { generateDynamicFormFields } from '../../../common/commonFunctions';
export default function FormTabs(props) {
    var _a = props.valueExpr, valueExpr = _a === void 0 ? 'id' : _a, _b = props.displayExpr, displayExpr = _b === void 0 ? 'name' : _b, _c = props.tabs, tabs = _c === void 0 ? [] : _c, value = props.value, tabProps = props.tabProps, onChange = props.onChange, name = props.name, formLoop = props.formLoop, _d = props.panelGridProps, panelGridProps = _d === void 0 ? {} : _d, 
    // getActiveTabElements,
    _e = props.stackContainerProps, 
    // getActiveTabElements,
    stackContainerProps = _e === void 0 ? {} : _e, _f = props.tabPanelProps, tabPanelProps = _f === void 0 ? {} : _f, _g = props.disableDivider, disableDivider = _g === void 0 ? false : _g, errors = props.errors, others = _objectWithoutProperties(props, _excluded);
    var tabErrors = useMemo(function () {
        var newErrors = tabs === null || tabs === void 0 ? void 0 : tabs.reduce(function (acc, tabItem) {
            var _a;
            var isTabError = false;
            if (tabItem.elements) {
                var _generateDynamicFormF;
                (_generateDynamicFormF = generateDynamicFormFields(tabItem.elements)) === null || _generateDynamicFormF === void 0 || _generateDynamicFormF.some(function (field) {
                    if (!(field !== null && field !== void 0 && field.name))
                        return false;
                    isTabError = Boolean(errors === null || errors === void 0 ? void 0 : errors[field.name]);
                    return isTabError;
                });
            }
            return _objectSpread(_objectSpread({}, acc), {}, (_a = {},
                _a[tabItem[valueExpr]] = isTabError,
                _a));
        }, {});
        return newErrors;
    }, [errors, tabs]);
    return /*#__PURE__*/ React.createElement(TabContext, {
        value: value
    }, /*#__PURE__*/ React.createElement(Stack, _extends({
        direction: "column",
        flexGrow: 1,
        columnGap: 2
    }, stackContainerProps), /*#__PURE__*/ React.createElement(Tabs, _extends({
        value: value,
        autoCapitalize: "off",
        onChange: onChange,
        TabIndicatorProps: {
            sx: {
                bgcolor: tabErrors[value] ? 'error.main' : undefined
            }
        }
    }, others), tabs === null || tabs === void 0 ? void 0 : tabs.map(function (item) {
        var _a;
        return React.createElement(Tab, _extends({
            id: item[valueExpr],
            value: item[valueExpr],
            label: item[displayExpr],
            icon: tabErrors[item[valueExpr]] && /*#__PURE__*/ React.createElement(WarningAmberRounded, {
                color: "error"
            }),
            iconPosition: "end"
        }, tabProps, item.tabProps, {
            sx: (_a = {
                    color: tabErrors[item[valueExpr]] ? 'error.500' : undefined
                },
                _a["&.".concat(tabClasses.selected)] = {
                    color: tabErrors[item[valueExpr]] ? 'error.500' : undefined
                },
                _a)
        }));
    })), !disableDivider && /*#__PURE__*/ React.createElement(Divider, {
        variant: "fullWidth"
    }), tabs === null || tabs === void 0 ? void 0 : tabs.map(function (item) {
        var _item$elements, _item$elements2;
        return ((item === null || item === void 0 ? void 0 : item.element) || (item === null || item === void 0 || (_item$elements = item.elements) === null || _item$elements === void 0 ? void 0 : _item$elements.length)) && /*#__PURE__*/ React.createElement(TabPanel, _extends({
            key: item[valueExpr]
        }, tabPanelProps, {
            sx: _objectSpread({
                px: 0,
                py: 2,
                flexGrow: 1
            }, tabPanelProps.sx),
            value: item[valueExpr]
        }), item.element ? item.element(props) : item.elements && /*#__PURE__*/ React.createElement(Grid, _extends({
            container: true,
            spacing: 2
        }, panelGridProps, item.containerProps), formLoop && ((_item$elements2 = item.elements) === null || _item$elements2 === void 0 ? void 0 : _item$elements2.map(formLoop))));
    })));
}
